import { render, staticRenderFns } from "./BudgetProjectionReview.vue?vue&type=template&id=51e42328&"
import script from "./BudgetProjectionReview.vue?vue&type=script&lang=js&"
export * from "./BudgetProjectionReview.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports